import 'css-chunksrc/client/scenes/moveDocument/folderSelection/styles.scss';export default {
  "input": "_input_1bb94_1",
  "placeholder": "_placeholder_1bb94_15",
  "icon": "_icon_1bb94_22",
  "listRoot": "_listRoot_1bb94_28",
  "list": "_list_1bb94_28",
  "opened": "_opened_1bb94_44",
  "project": "_project_1bb94_53",
  "projectIcon": "_projectIcon_1bb94_64"
};